import { cn } from "@/lib/utils";
import { motion } from "motion/react";
import { type ComponentProps, memo, useMemo } from "react";
import Text from "../text/text";

function ShimmerComponent({
  spread = 2,
  duration = 2,
  children,
  className,
  ...props
}: Omit<ComponentProps<typeof Text>, "children"> & {
  spread?: number;
  children?: string;
  duration?: number;
}) {
  const Motion = motion.create(Text);

  const dynamicSpread = useMemo(
    () => (children?.length ?? 0) * spread,
    [children, spread],
  );

  return (
    // eslint-disable-next-line react-hooks/static-components
    <Motion
      style={{
        "--spread": `${dynamicSpread}px`,
        backgroundImage:
          "var(--bg), linear-gradient(var(--color-gray-400), var(--color-gray-400))",
      }}
      animate={{ backgroundPosition: "0% center" }}
      initial={{ backgroundPosition: "100% center" }}
      className={cn(
        "relative inline-block bg-size-[250%_100%,auto] bg-clip-text text-transparent",
        "[background-repeat:no-repeat,padding-box] [--bg:linear-gradient(90deg,#0000_calc(50%-var(--spread)),var(--color-background),#0000_calc(50%+var(--spread)))]",
        className,
      )}
      transition={{
        repeat: Number.POSITIVE_INFINITY,
        duration,
        ease: "linear",
      }}
      {...props}
    >
      {children}
    </Motion>
  );
}

const Shimmer = memo(ShimmerComponent);
export default Shimmer;
